import { IconButton, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useShowDrawer } from '../../../shared';
import MenuIcon from '@mui/icons-material/Menu';

export const AppTitle: FC = () => {
    const navigate = useNavigate();
    const { showDrawer, setShowDrawer } = useShowDrawer();
    const { logo } = window.carity.environment.theme;

    return (
        <Stack
            direction="row"
            id="app-title"
            justifyContent="space-between"
            sx={{ justifyContent: { xs: 'space-between', lg: 'flex-start' } }}
        >
            <img src={logo} style={{ cursor: 'pointer' }} alt="Carity" onClick={() => navigate('')} />
            <Typography variant="h1" sx={{ width: 'fit-content', pr: 0, display: { xs: 'none', lg: 'inline-flex' } }}>
                carity<strong>logistics</strong>
            </Typography>
            <IconButton
                color="inherit"
                edge="start"
                onClick={() => setShowDrawer(!showDrawer)}
                sx={{ px: 2, display: { xs: 'inline-flex', lg: 'none' } }}
            >
                <MenuIcon />
            </IconButton>
        </Stack>
    );
};
